/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DocumentUrlUpdate = {
  status: string;
};

/** @internal */
export const DocumentUrlUpdate$inboundSchema: z.ZodType<
  DocumentUrlUpdate,
  z.ZodTypeDef,
  unknown
> = z.object({
  status: z.string(),
});
/** @internal */
export type DocumentUrlUpdate$Outbound = {
  status: string;
};

/** @internal */
export const DocumentUrlUpdate$outboundSchema: z.ZodType<
  DocumentUrlUpdate$Outbound,
  z.ZodTypeDef,
  DocumentUrlUpdate
> = z.object({
  status: z.string(),
});

export function documentUrlUpdateToJSON(
  documentUrlUpdate: DocumentUrlUpdate,
): string {
  return JSON.stringify(
    DocumentUrlUpdate$outboundSchema.parse(documentUrlUpdate),
  );
}
export function documentUrlUpdateFromJSON(
  jsonString: string,
): SafeParseResult<DocumentUrlUpdate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentUrlUpdate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentUrlUpdate' from JSON`,
  );
}
